export const RFC_FIELDS = {
    credit_score_data: 'credit_score_data',
    financial_pendings_data: 'financial_pendings_data',
}
